var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[(_vm.settings.licence_id)?_c('iframe',{staticClass:"analytics-iframe",attrs:{"src":`${_vm.iframeUrl}?accountKey=${_vm.settings.licence_id}`,"width":"100%","frameborder":"0","id":"analytics-iframe"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }